module.exports = __webpack_public_path__ + "static/img/labeled-ear-illustration-zh.c74742ab.png";